//!!! DO NOT EDIT THIS FILE, IT IS AUTO-GENERATED !!!//

import { Agent } from '../../Agent/Agent.class';
import { createSafeAccessor } from '../utils';
import { ComponentWrapper } from '../ComponentWrapper.class';
import { InputSettings, ComponentInput } from '../../types/SDKTypes';

export interface TMCPClientSettings {
    model?: string;
    openAiModel: string;
    /** Description for Model */
    descForModel: string;
    name: string;
    /** Description */
    desc: string;
    logoUrl?: string;
    id?: string;
    version?: string;
    domain?: string;
    /** Prompt */
    prompt?: string;
}

export type TMCPClientInputs = {
    [key: string]: InputSettings;
};

export type TMCPClientOutputs = {
    [key: string]: any;
};

export function MCPClient(settings?: TMCPClientSettings, agent?: Agent) {    
    const { name, ...settingsWithoutName } = settings || {};
    const dataObject: any = { 
        name: settings?.name || 'MCPClient', 
        settings: {
            ...settingsWithoutName 
        }
    };
    const component = new ComponentWrapper(dataObject, agent);

    if (agent) {
        (agent.structure.components as ComponentWrapper[]).push(component);
    }
    
    const _out: TMCPClientOutputs = createSafeAccessor({
        // No outputs defined
    }, component, '');

    const _in: { [key: string]: ComponentInput } = {
        // No inputs defined
    };

    dataObject.outputs = _out;
    dataObject.inputs = _in;

    component.inputs(_in);

    const wrapper = {
        /** Component outputs - access via .out.OutputName */
        out: _out,        

        /** 
         * Create or Connect the component inputs 
         * if the input does not exist, it will be created
         * @examples 
         *    - component.in({ Input: source.out.data })
         *    - component.in({ Input: { type: 'string', source:source.out.data } })
         */        
        in: component.inputs.bind(component) as (inputs: TMCPClientInputs) => void,
    };

    return wrapper;
}
